import { createFileRoute } from '@tanstack/react-router';

import { TemplateAssemblyPage } from '@pages/templates/template-assembly-page.js';
import { IamService } from '@units/iam';

/**
 * `/templates/$templateId_/assemblies/$assemblyId` — wiring only.
 *
 * Гард — `template:read`, тот же вопрос, что у карточки формы (см. её докстринг про отсутствие
 * ресурсного ACL в текущей версии контракта). Выгрузка файлом — отдельное право
 * `template:export_document`, проверенное сервером на своей операции и подсказкой скрытое здесь на
 * уровне компонента, а не гарда: сборку можно посмотреть, не имея права её скачать.
 *
 * **Не дочерний маршрут карточки** — тот же приём `$templateId_`, что у `fill.tsx`, и по той же
 * причине: страница сборки несёт собственный `PageHeader`, а не встаёт вкладкой внутри карточки.
 * См. докстринг `fill.tsx` — там разбор подробный, здесь не повторяется.
 */
export const Route = createFileRoute(
  '/_authenticated/templates/$templateId_/assemblies/$assemblyId',
)({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'template:read',
    whenDenied: 'forbidden',
  }),
  component: TemplateAssemblyPage,
  staticData: { crumbKey: 'templates.assembly.title' },
});
